import Request from "@/common/net/request.js";
const request = new Request();
// 获取列表
export function getPage(data) {
  return request.send({
    url: `/pmy/sys/company/page`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json",
      },
    },
  });
}
// 添加
export function addInfo(data) {
  return request.send({
    url: `/pmy/sys/company`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json",
      },
    },
  });
}

// 编辑
export function editInfo(data) {
  return request.send({
    url: `/pmy/sys/company`,
    method: "put",
    data,
    config: {
      headers: {
        "Content-Type": "application/json",
      },
    },
  });
}

// 删除
export function deleteInfo(companyId) {
  return request.send({
    url: `/pmy/sys/company?companyId=${companyId}`,
    method: "delete",
  });
}
// 重置密码
export function resetPassword(data) {
  return request.send({
    url: `/pmy/sys/company/pwd`,
    method: "put",
    data,
    config: {
      headers: {
        "Content-Type": "application/json",
      },
    },
  });
}
// 详情
export function detailInfo(companyId) {
  return request.send({
    url: `/pmy/sys/company?companyId=${companyId}`,
    method: "get",
  });
}

// 获取服务商（包含总公司-分公司）
export function getSelectCompany() {
  return request.send({
    url: `/pmy/sys/company/base/all`,
    method: "get",
  });
}
